module.exports = __webpack_public_path__ + "static/media/skater5.e1fae33f.jpg";